import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/product/page-client.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["useTina"] */ "/vercel/path0/lib/use-tina.js");
